import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "subpathinfo"
    }}>{`SubPathInfo`}</h1>
    <p>{`An array of `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathpointinfo/"
      }}>{`PathPointInfo`}</a>{` objects that describes a straight or curved segment of a path, used to create
a `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathitem/"
      }}>{`SubPathItem`}</a>{`.`}</p>
    <p>{`Pass an array of these objects to the `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitems/#add"
      }}>{`PathItems.add`}</a>{`() method. This method creates a `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/subpathitem/"
      }}>{`SubPathItem`}</a>{` object
for each `}<inlineCode parentName="p">{`SubPathInfo`}</inlineCode>{` object, and creates and returns a new `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathitem/"
      }}>{`PathItem`}</a>{` object for the path represented by
all of the subpaths.`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Use `}<inlineCode parentName="p">{`SubPathInfo`}</inlineCode>{` to create subpaths; the properties are read-write.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Use the `}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/subpathitem/"
          }}>{`SubPathItem`}</a>{` object to retrieve information about existing subpaths. The properties are read-only.`}</p>
      </li>
    </ul>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <h3 {...{
      "id": "closed"
    }}>{`closed`}</h3>
    <p>{`• `}<strong parentName="p">{`closed`}</strong>{`: `}<em parentName="p">{`boolean`}</em></p>
    <p>{`True if the path describes an enclosed area.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "entiresubpath"
    }}>{`entireSubPath`}</h3>
    <p>{`• `}<strong parentName="p">{`entireSubPath`}</strong>{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/pathpointinfo/"
      }}><em parentName="a">{`PathPointInfo`}</em></a>{`[]`}</p>
    <hr></hr>
    <h3 {...{
      "id": "operation"
    }}>{`operation`}</h3>
    <p>{`• `}<strong parentName="p">{`operation`}</strong>{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/modules/constants/#shapeoperation"
      }}><em parentName="a">{`ShapeOperation`}</em></a></p>
    <p>{`The subpath's operation on other subpaths. Specifies how to combine the shapes if
the destination path already has a selection.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "typename"
    }}>{`typename`}</h3>
    <p>{`• `}<inlineCode parentName="p">{`Readonly`}</inlineCode>{` `}<strong parentName="p">{`typename`}</strong>{`: `}<em parentName="p">{`string`}</em></p>
    <p>{`The class name of the referenced object`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      